import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bidsandsaves',
  templateUrl: './bidsandsaves.component.html',
  styleUrls: ['./bidsandsaves.component.scss']
})
export class BidsandsavesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
